import * as net from 'util/Net';

interface ConfirmMfaSetupResponse {
  success: boolean;
}

export function confirmMfaSetup(code: string): Promise<ConfirmMfaSetupResponse> {
  return net.postJSONPromise({url: '/settings/mfa', data: {code}});
}
